require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/library/modules/es7.symbol.observable.js
// module id = 1526
// module chunks = 0